import { render, staticRenderFns } from "./RiskEvaluationTable.vue?vue&type=template&id=6eef46dc&scoped=true"
import script from "./RiskEvaluationTable.vue?vue&type=script&lang=js"
export * from "./RiskEvaluationTable.vue?vue&type=script&lang=js"
import style0 from "./RiskEvaluationTable.vue?vue&type=style&index=0&id=6eef46dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eef46dc",
  null
  
)

export default component.exports